export default __webpack_public_path__ + "static/media/20-21.9f327dda.png";